import * as searchConstants from '../../search-constants.js';

function clearDestinationValues() {
  this.$data.settings.currentDestinations = '';
  this.$data.settings.currentContinent = '';
  this.$data.settings.currentSearchPrefix = searchConstants.DEFAULTSEARCHTERM;
}
export default clearDestinationValues;
